import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  iconPack: 'mdi',
  duration: 7000
})

Vue.toasted.register('error', (payload) => {
  // if there is no message passed show default message
  if (!payload.message) {
    return 'Oops... Dados inválidos'
  }

  // if there is a message show it with the message
  return 'Oops... ' + payload.message
},
{
  type: 'error',
  icon: 'alert-circle'
})

Vue.toasted.register('success', (payload) => {
  // if there is no message passed show default message
  if (!payload.message) {
    return 'Operação realizada com sucesso.'
  }

  // if there is a message show it with the message
  return payload.message
},
{
  type: 'success',
  icon: 'check'
})

Vue.toasted.register('info', (payload) => {
  // if there is no message passed show default message
  if (!payload.message) {
    return 'Ok.'
  }

  // if there is a message show it with the message
  return payload.message
},
{
  type: 'info',
  icon: 'information'
})
